// extracted by mini-css-extract-plugin
export default {"root":"FieldWithCurrency_root__Rsa5V","fieldWithCurrency":"FieldWithCurrency_fieldWithCurrency__F2a6u","select":"FieldWithCurrency_select__qCQuA"};